import { render, staticRenderFns } from "./agreement-policy.vue?vue&type=template&id=13b98afe&scoped=true";
import script from "./agreement-policy.vue?vue&type=script&lang=js";
export * from "./agreement-policy.vue?vue&type=script&lang=js";
import style0 from "./agreement-policy.vue?vue&type=style&index=0&id=13b98afe&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "13b98afe", null);
export default component.exports;